import { PlusCircle } from "react-feather";
interface props {
    label: string;
    addFunction: () => {};
    deleteFunction?: () => {};
    updateFunction: () => {};
    createFunction: () => {};
    isNew: Boolean | undefined;
}
function TopBar(props: props) {
    return (
        <>
            <div className="topSection">
                <div className="sectionHeader">
                    <PlusCircle
                        className="headerIcon"
                        onClick={props.addFunction}
                    ></PlusCircle>{" "}
                    {props.label}
                </div>
                {props.isNew == false && (
                    <div>
                        {props.deleteFunction && (
                            <button
                                className="g-btn-large btn-warning"
                                onClick={props.deleteFunction}
                            >
                                {" "}
                                {"Delete " + props.label}
                            </button>
                        )}
                        <button
                            className="g-btn-large btn-primary"
                            onClick={props.updateFunction}
                        >
                            {" "}
                            {"Update " + props.label}
                        </button>
                    </div>
                )}
                {props.isNew == true && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={props.createFunction}
                        >
                            {" "}
                            {"Create " + props.label}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
export default TopBar;
